import {remCalc} from '_themeUtils'

const wallMixedImage = {
    WallMixedImage: {
        baseStyle: ({
            text_align,
            h_align,
            v_align,
            imagePadding,
            button_background,
            content_color,
            button_color,
            layout_text_below_image,
            mobileSideBySide,
        }) => ({
            imageWrapper: {
                position: 'relative',
                w: '100%',
                h: 'full',
                overflow: 'hidden',
                gap: 'spacing.4',
            },
            wrapperOverlay: {
                position: 'relative',
                w: '100%',
                aspectRatio: {base: 750 / 1071, md: 256 / 365, lg: 854 / 1219},
            },
            overlay: {
                h: '100%',
                w: '100%',
                position: 'absolute',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0,0,0,0.2)',
            },
            link: {
                position: 'relative',
                padding: `${imagePadding.top}px ${imagePadding.right}px ${imagePadding.bottom}px ${imagePadding.left}px`,
                w: 'full',
            },
            titleContainer: {
                position: 'absolute',
                right: {base: imagePadding.right + (mobileSideBySide ? 24 : 48) + 'px', md: imagePadding.right + 48 + 'px'},
                bottom: {base: imagePadding.bottom + (mobileSideBySide ? 24 : 48) + 'px', md: imagePadding.bottom + 48 + 'px'},
                left: {base: imagePadding.left + (mobileSideBySide ? 24 : 48) + 'px', md: imagePadding.left + 48 + 'px'},
                top: {base: imagePadding.top + (mobileSideBySide ? 24 : 48) + 'px', md: imagePadding.top + 48 + 'px'},
                textAlign: text_align || 'center',
                alignItems: h_align === 'left' ? 'flex-start' : h_align === 'right' ? 'flex-end' : 'center',
                justifyContent: v_align === 'top' ? 'flex-start' : v_align === 'bottom' ? 'flex-end' : 'center',
                gap: 'spacing.4',
            },
            titleContainerBelow: {
                w: 'full',
                h: 'full',
                padding: `${imagePadding.top}px ${imagePadding.right}px ${imagePadding.bottom}px ${imagePadding.left}px`,
                justifyContent: 'center',
                textAlign: text_align || 'center',
                alignItems: h_align === 'left' ? 'flex-start' : h_align === 'right' ? 'flex-end' : 'center',
                gap: 'spacing.4',
            },
            title: {
                color: content_color ? content_color : 'color.text.black',
                textStyle: {base: mobileSideBySide ? 'paragraphLg' : 'displayXs', md: 'displayXs'},
                fontWeight: 'normal',
            },
            titleBelow: {
                color: content_color ? content_color : 'color.text.black',
                textStyle: {base: mobileSideBySide ? 'paragraphLg' : 'displayXs', md: 'displayXs'},
                fontWeight: 'normal',
            },
            text: {
                width: '75%',
                color: content_color ? content_color : 'color.text.black',
                fontWeight: 'normal',
                textStyle: {base: mobileSideBySide ? 'paragraphSm' : 'paragraphLg', md: 'paragraphLg'},
                sx: {wordWrap: 'normal'},
            },
            textBelow: {
                width: '90%',
                color: content_color ? content_color : 'color.text.black',
                fontWeight: 'light',
                textStyle: {base: mobileSideBySide ? 'paragraphSm' : 'paragraphLg', md: 'paragraphLg'},
                sx: {wordWrap: 'normal'},
            },
            textCta: {
                color: button_color ? button_color : layout_text_below_image ? 'color.text.black' : 'color.text.white',
                position: 'relative',
                _before: {
                    content: "''",
                    display: layout_text_below_image ? 'none' : 'block',
                    position: 'relative',
                    zIndex: 1,
                    width: remCalc(32),
                    height: '2px',
                    background: button_color ? button_color : 'color.text.white',
                    left: '50%',
                    transform: 'translateX(-50%)',
                },
            },
            buttonColor: {
                color: button_color ? button_color : 'color.text.white',
                background: button_background,
                borderColor: button_background,
                letterSpacing: remCalc(4),
            },
            outlineButton: {
                color: button_color ? button_color : 'color.text.black',
                letterSpacing: remCalc(4),
            },
            ctaLinkStyle: {
                color: button_color ? button_color : layout_text_below_image ? 'color.text.black' : 'color.text.white',
                letterSpacing: remCalc(3),
                borderBottomColor: button_color,
                p: {base: `${remCalc(7)}, ${remCalc(7)}, ${remCalc(2)}`, md: remCalc(7)},
                display: {base: 'inline', md: 'inline-flex'},
                whiteSpace: 'normal',
                lineHeight: layout_text_below_image ? remCalc(50) : 'px',
                fontSize: {base: mobileSideBySide ? remCalc(12) : layout_text_below_image ? remCalc(14) : 'md', md: 'md'},
                fontWeight: 400,
                _hover: {
                    color: button_color ? button_color : layout_text_below_image ? 'color.text.black' : 'color.text.white',
                    borderBottomColor: button_color,
                    background: 'none',
                    textDecoration: 'none',
                    filter: 'none',
                    opacity: 1,
                },
                _active: {
                    color: button_color ? button_color : layout_text_below_image ? 'color.text.black' : 'color.text.white',
                    borderBottomColor: button_color,
                    background: 'none',
                    textDecoration: 'none',
                    filter: 'none',
                    opacity: 1,
                },
                _focus: {
                    color: button_color ? button_color : layout_text_below_image ? 'color.text.black' : 'color.text.white',
                    borderBottomColor: button_color,
                    background: 'none',
                    textDecoration: 'none',
                    filter: 'none',
                    opacity: 1,
                },
            },
        }),
    },
}

export default wallMixedImage
